module.exports = __webpack_public_path__ + "static/gatech.0c596cab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/highered_logos/gatech.png
// module id = 2183
// module chunks = 61762850755587